import {
  ButtonContext,
  DynamicListDataEntry,
  type DynamicListDataEntryProps,
} from '@axinom/mosaic-ui';
import React, { useMemo, useState } from 'react';
import { RoleSelectionExplorer } from './RoleSelectionExplorer';
import type { UserRoleAssignment } from './RoleSelectionExplorer/models';

interface UseUserRoleSelectFieldDataEntryOptions {
  environmentId: string;
  initialRoles: UserRoleAssignment[];
  currentRoles: UserRoleAssignment[];
}

interface UseUserRoleSelectFieldDataEntryResult {
  UserRoleSelectFieldDataEntry: React.FC<
    DynamicListDataEntryProps<UserRoleAssignment>
  >;
}

export const useUserRoleSelectFieldDataEntry = (
  options: UseUserRoleSelectFieldDataEntryOptions,
): UseUserRoleSelectFieldDataEntryResult => {
  const UserRoleSelectFieldDataEntry: React.FC<
    DynamicListDataEntryProps<UserRoleAssignment>
  > = useMemo(() => {
    const UserRoleSelectFieldDataEntry: React.FC<
      DynamicListDataEntryProps<UserRoleAssignment>
    > = (props) => {
      const [showModal, setShowModal] = useState<boolean>(false);

      const onNewRoleHandler = (newRole: UserRoleAssignment): void => {
        setShowModal(false);
        props.onActionClicked && props.onActionClicked(newRole);
      };

      return (
        <>
          <DynamicListDataEntry
            {...props}
            onActionClicked={() => setShowModal(true)}
            actionButtonContext={ButtonContext.Active}
          />
          <RoleSelectionExplorer
            environmentId={options.environmentId}
            isModalShown={showModal}
            initialRoles={options.initialRoles}
            currentRoles={options.currentRoles}
            title="Select Role(s)"
            onNewRoleAssignments={onNewRoleHandler}
            onClose={() => setShowModal(false)}
          />
        </>
      );
    };

    return UserRoleSelectFieldDataEntry;
  }, [options.currentRoles, options.environmentId, options.initialRoles]);

  return { UserRoleSelectFieldDataEntry };
};
